import { Collection } from 'backbone';
import _ from 'lodash';

export class Winners extends Collection {
	initialize(){
		this.setApiUrl();
		this.prefix = 'nrl/';
	}

	setApiUrl() {
		this.url = 'winners_monthly.json';
		return this;
	}

	getSortedWinners() {
		let winners = this.toJSON(),
			sorted_winners = {},
			winner_month = "";
		_.each( winners, winner => {
			if( winner_month === "" || winner.month !== winner_month ) {
				winner_month = winner.month;
				sorted_winners[winner_month] = [];
			}
			sorted_winners[winner_month].push(winner);
		} );

		return sorted_winners;
	}
}

export default Winners;